import { render, staticRenderFns } from "./NipponColors.vue?vue&type=template&id=3c615327&"
import script from "./NipponColors.vue?vue&type=script&lang=js&"
export * from "./NipponColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports